import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { isIE, isEdge } from 'element-ui/src/utils/util';
import ElementUI from 'element-ui';
import moment from 'moment'
import 'element-ui/lib/theme-chalk/index.css';

Vue.config.productionTip = false
Vue.prototype.$moment = moment

import LoginDialog from "./component/LoginDialog"
Vue.component('LoginDialog', LoginDialog)

// 富文本
import "@wangeditor/editor/dist/css/style.css"

// element 选择输入框兼容Safari
const { Select } = ElementUI
Select.props.popperAppendToBody.default = false
Select.props.banReadonly = {
  type: Boolean,
  default: true
}
Select.computed.readonly = function () {
  return !this.banReadonly && (!this.filterable || this.multiple || (!isIE() && !isEdge() && !this.visible))
}

Vue.prototype.$bus = new Vue()

Vue.use(ElementUI);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
